import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Button,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    OutlinedInput,
    Chip
} from '@mui/material';
import { IoIosCloseCircle } from "react-icons/io";
import axios from 'axios';

const EditChatUsers = ({ open, onClose, group, users, onUpdate, closeAllPopups, isCaseChat }) => {
    const [chatName, setChatName] = useState(group.chatName);
    const [selectedUsers, setSelectedUsers] = useState(group.chatUsersIds);
    const [isModified, setIsModified] = useState(false);

    const rolesInGeorgian = {
        'HEADOFAGENCY': "სააგენტოს უფროსი",
        'DEPUTYHEADOFAGENCY': "უფროსის მოადგილე",
        'HEADOFDEPARTMENT': "სამმართველოს უფროსი",
        'EXPERT': "სპეციალისტი"
    };

    useEffect(() => {
        setChatName(group.chatName);
        setSelectedUsers(group.chatUsersIds);
    }, [group]);

    useEffect(() => {
        const hasChanged = chatName !== group.chatName || selectedUsers.sort().toString() !== group.chatUsersIds.sort().toString();
        setIsModified(hasChanged);
    }, [chatName, selectedUsers, group.chatName, group.chatUsersIds]);

    const handleUpdateChatGroup = async () => {
        if (!isModified) return; // Prevent update if nothing has changed

        const payload = {
            id: group.id,
            chatName: chatName,
            chatUsersIds: selectedUsers,
            caseNumber: group.caseNumber,
            caseID: group.caseID
        };

        try {
            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditChatGroup`, payload);
            onClose();
            onUpdate();
            closeAllPopups();
        } catch (error) {
            console.error('Failed to update chat group:', error);
        }
    };

    return (
        <Dialog fullWidth maxWidth="lg" open={open} onClose={onClose}>
            <IoIosCloseCircle className="close-icon" onClick={onClose}/>
            <DialogTitle>ჩატის რედაქტირება</DialogTitle>
            <DialogContent>
                {!isCaseChat && (
                    <TextField
                        label="ჩატის სახელი"
                        fullWidth
                        margin="dense"
                        value={chatName}
                        onChange={(e) => setChatName(e.target.value)}
                    />
                )}

                <FormControl fullWidth margin="dense">
                    <InputLabel>მომხამრებლები</InputLabel>
                    <Select
                        multiple
                        value={selectedUsers}
                        onChange={(e) => setSelectedUsers(e.target.value)}
                        input={<OutlinedInput label="მომხამრებლები"/>}
                        renderValue={(selected) => (
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                {selected.map((id) => {
                                    const user = users.find(u => u.id === id);
                                    return user ? <Chip key={id} label={`${user.firstName} ${user.lastName}`} /> : null;
                                })}
                            </div>
                        )}

                    >
                        {users.map((user) => (
                            <MenuItem key={user.id} value={user.id}>
                                {user.firstName} {user.lastName} ( { rolesInGeorgian[user.roleName.toUpperCase()]})
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleUpdateChatGroup} color="primary" disabled={!isModified}>
                    რედაქტირება
                </Button>
                <Button onClick={onClose} color="secondary">
                    გაუქმება
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditChatUsers;
